<section class="product-lookup">
  @if (permissions.can('products', 'view')) {
    <button
      pButton
      type="button"
      class="product-lookup__trigger p-button-text"
      data-testid="product-lookup-open"
      data-tour="global.product-search"
      aria-label="Consultar produto (F3)"
      title="Consultar produto (F3)"
      (click)="open()">
      <lucide-icon class="product-lookup__trigger-mobile-icon" name="search" [size]="16" aria-hidden="true" />
      <kbd class="product-lookup__trigger-kbd">F3</kbd>
      <span class="product-lookup__trigger-label">Consultar produto</span>
      <span class="product-lookup__trigger-short-label">Produto</span>
    </button>
  }

  <p-dialog
    header="Consultar produto"
    closeAriaLabel="Fechar consulta de produto"
    styleClass="product-lookup-dialog"
    maskStyleClass="backdrop-blur-sm"
    [visible]="visible()"
    (visibleChange)="$event ? open() : close()"
    (onShow)="onDialogShow()"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    appendTo="body"
    [style]="{ width: 'min(42rem, calc(100vw - 2rem))' }">
    <div class="product-lookup__content">
      <form class="product-lookup__search" data-testid="product-lookup-form" (submit)="$event.preventDefault(); search()">
        <label for="product-lookup-query" class="product-lookup__search-label">
          <span>Nome, código ou código de barras</span>
        </label>
        <div class="product-lookup__search__fields">
          <div class="product-lookup__input-wrapper">
            <lucide-icon name="search" [size]="16" class="product-lookup__search-icon" aria-hidden="true" />
            <input
              #queryInput
              pInputText
              id="product-lookup-query"
              data-testid="product-lookup-query"
              [formControl]="query"
              autocomplete="off"
              placeholder="Digite ou use o leitor"
              class="product-lookup__input" />
          </div>
          <button
            pButton
            type="submit"
            class="product-lookup__submit-btn"
            data-testid="product-lookup-search"
            [disabled]="!query.value.trim()">
            <lucide-icon name="search" [size]="15" class="mr-2" aria-hidden="true" />
            <span>Buscar</span>
          </button>
        </div>
        <small class="product-lookup__search-hint">
          <lucide-icon name="barcode" [size]="14" aria-hidden="true" />
          <span>Use o leitor mesmo sem selecionar o campo.</span>
        </small>
      </form>

      <div class="product-lookup__results" aria-live="polite" [attr.aria-busy]="loading()">
        @if (loading()) {
          <div class="product-lookup__loading" role="status">
            <lucide-icon name="loader" [size]="20" class="product-lookup__spinner" aria-hidden="true" />
            <span>Buscando produto…</span>
          </div>
        } @else if (error()) {
          <app-feedback-message severity="error" message="Não foi possível consultar produtos. Tente novamente." />
        } @else if (products().length) {
          @for (product of products(); track $index) {
            <article class="product-lookup__card">
              <header class="product-lookup__card-header">
                <div class="product-lookup__card-icon">
                  <lucide-icon name="package" [size]="20" aria-hidden="true" />
                </div>
                <div class="product-lookup__card-info">
                  <h3 class="product-lookup__card-title">{{ product.name }}</h3>
                  <div class="product-lookup__card-meta">
                    @if (product.sku) {
                      <app-badge
                        tone="slate"
                        size="sm"
                        [fontMono]="true"
                        icon="barcode"
                        [label]="product.sku" />
                    }
                    <small class="product-lookup__card-sku-fallback visually-hidden">{{ product.sku }}</small>
                  </div>
                </div>
              </header>

              <div class="product-lookup__card-grid">
                <div class="product-lookup__metric product-lookup__metric--price">
                  <span class="product-lookup__metric-label">Preço unitário</span>
                  <strong class="product-lookup__results__item__price product-lookup__price-val" data-testid="product-lookup-price">
                    {{ product.unitPrice === null ? 'Preço não cadastrado' : (product.unitPrice | currency: 'BRL') }}
                  </strong>
                </div>

                <div class="product-lookup__metric product-lookup__metric--stock">
                  <span class="product-lookup__metric-label">Disponibilidade</span>
                  <div class="product-lookup__stock-status" data-testid="product-lookup-stock">
                    @if (!product.trackStock) {
                      <app-badge tone="neutral" size="md" icon="box" label="Não controla estoque" />
                    } @else if (permissions.can('inventory', 'view')) {
                      <app-badge
                        tone="green"
                        size="md"
                        icon="layers"
                        [label]="'Estoque disponível: ' + (product.quantityAvailable | number: '1.0-3') + ' ' + product.unitOfMeasureSymbol" />
                    } @else {
                      <app-badge tone="amber" size="md" icon="alert-circle" label="Sem permissão para consultar estoque" />
                    }
                  </div>
                </div>
              </div>
            </article>
          }
        } @else {
          <div class="product-lookup__empty">
            <app-empty-state
              icon="package"
              [title]="searched() ? 'Nenhum produto encontrado' : 'Busque ou escaneie um produto'"
              [subtitle]="searched() ? 'Confira o código ou tente outro nome.' : 'Consulte preço e estoque sem alterar a venda.'" />
          </div>
        }
      </div>
    </div>
  </p-dialog>
</section>
